// extracted by mini-css-extract-plugin
export default {"tabs_wrap":"CustomTabs_tabs_wrap__FUtxE"};